import script from "./GoogleMyBusinessForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleMyBusinessForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__